// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progressBar {
  margin: 100px auto;
  width: 60px;
  height: 50px;
  text-align: center;
  font-size: 10px;
}

.progressBar > div {
  background-color: #333;
  height: 100%;
  width: 6px;
  display: inline-block;
  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.progressBar > div.blue {
  background-color: #1890ff;
  margin: 0 2px;
}

.progressBar > div.white {
  background-color: #ffffff;
  margin: 0 2px;
}
.progressBar .rect1 {
  -webkit-animation-delay: -1.4s;
  animation-delay: -1.4s;
}
.progressBar .rect2 {
  -webkit-animation-delay: -1.2s;
  animation-delay: -1.2s;
}

.progressBar .rect3 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

.progressBar .rect4 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

.progressBar .rect5 {
  -webkit-animation-delay: -0.6s;
  animation-delay: -0.6s;
}

@-webkit-keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
  }
}

@keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}
`, "",{"version":3,"sources":["webpack://./client/components/ProgressBar/progressBar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,4DAA4D;EAC5D,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE;;;IAGE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;;;IAGE,sBAAsB;IACtB,8BAA8B;EAChC;EACA;IACE,oBAAoB;IACpB,4BAA4B;EAC9B;AACF","sourcesContent":[".progressBar {\n  margin: 100px auto;\n  width: 60px;\n  height: 50px;\n  text-align: center;\n  font-size: 10px;\n}\n\n.progressBar > div {\n  background-color: #333;\n  height: 100%;\n  width: 6px;\n  display: inline-block;\n  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;\n  animation: sk-stretchdelay 1.2s infinite ease-in-out;\n}\n\n.progressBar > div.blue {\n  background-color: #1890ff;\n  margin: 0 2px;\n}\n\n.progressBar > div.white {\n  background-color: #ffffff;\n  margin: 0 2px;\n}\n.progressBar .rect1 {\n  -webkit-animation-delay: -1.4s;\n  animation-delay: -1.4s;\n}\n.progressBar .rect2 {\n  -webkit-animation-delay: -1.2s;\n  animation-delay: -1.2s;\n}\n\n.progressBar .rect3 {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n.progressBar .rect4 {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n.progressBar .rect5 {\n  -webkit-animation-delay: -0.6s;\n  animation-delay: -0.6s;\n}\n\n@-webkit-keyframes sk-stretchdelay {\n  0%,\n  40%,\n  100% {\n    -webkit-transform: scaleY(0.4);\n  }\n  20% {\n    -webkit-transform: scaleY(1);\n  }\n}\n\n@keyframes sk-stretchdelay {\n  0%,\n  40%,\n  100% {\n    transform: scaleY(0.4);\n    -webkit-transform: scaleY(0.4);\n  }\n  20% {\n    transform: scaleY(1);\n    -webkit-transform: scaleY(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
